module.exports = __webpack_public_path__ + "img/three-step-md.bd6565d.png";